function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import * as React from "react";
import injectSheet from "react-jss";
import cx from "classnames";
import { string, number, shape, node, bool, arrayOf, func, oneOfType } from "prop-types";
import Hamburger from "./Hamburger";
// CSS
import styles from "./styles";
var _Component;
export var DefaultTheme = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(DefaultTheme, _superClass);
    var _super = _createSuper(DefaultTheme);
    function DefaultTheme() {
        _classCallCheck(this, DefaultTheme);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "state", {
            isMenuExpanded: false
        });
        _defineProperty(_assertThisInitialized(_this), "handleBurgerClick", function() {
            return _this.setState({
                isMenuExpanded: !_this.state.isMenuExpanded
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleTitleKeyPress", function(event) {
            if (event.which === 13 && event.ctrlKey) {
                _this.props.onTitleChange(event);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "handleNavClick", function(event) {
            event.preventDefault();
            _this.setState({
                isMenuExpanded: false
            });
            _this.props.onNavClick(event);
        });
        _defineProperty(_assertThisInitialized(_this), "handleLogin", function(event) {
            event.preventDefault();
            _this.props.onLoginClick();
            return false;
        });
        _defineProperty(_assertThisInitialized(_this), "handleRegister", function(event) {
            event.preventDefault();
            _this.props.onRegisterClick();
            return false;
        });
        return _this;
    }
    _createClass(DefaultTheme, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.mode !== this.props.mode) {
                    this.setState({
                        isMenuExpanded: false
                    });
                }
            }
        },
        {
            key: "renderAuthLinks",
            value: function renderAuthLinks() {
                var _props = this.props, showAuthLinks = _props.showAuthLinks, isMobile = _props.isMobile;
                if (showAuthLinks) {
                    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
                        className: cx({
                            "slds-text-heading_small": isMobile
                        }),
                        onClick: this.handleLogin,
                        href: "#login"
                    }, "Login")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
                        className: cx({
                            "slds-text-heading_small": isMobile
                        }),
                        onClick: this.handleRegister,
                        href: "#register"
                    }, "Register")));
                }
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, activePage = _props.activePage, backgroundColor = _props.backgroundColor, classes = _props.classes, children = _props.children, isEditable = _props.isEditable, isMobile = _props.isMobile, title = _props.title, logo = _props.logo, useLogoOriginalSize = _props.useLogoOriginalSize, onTitleChange = _props.onTitleChange;
                return /*#__PURE__*/ React.createElement("div", {
                    className: cx(classes.outerContainer, "slds-col")
                }, /*#__PURE__*/ React.createElement("div", {
                    className: cx(classes.container, _defineProperty({}, classes.mobile, isMobile))
                }, /*#__PURE__*/ React.createElement("div", {
                    className: classes.previewContainer,
                    style: {
                        backgroundColor: backgroundColor
                    }
                }, /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement(Hamburger, {
                    className: classes.hamburger,
                    isExpanded: this.state.isMenuExpanded,
                    onClick: this.handleBurgerClick
                }), /*#__PURE__*/ React.createElement("div", {
                    className: classes.bannerContainer
                }, /*#__PURE__*/ React.createElement("h1", {
                    className: cx("slds-text-heading_large", classes.bannerHeader)
                }, logo && /*#__PURE__*/ React.createElement("img", {
                    src: logo,
                    alt: "logo",
                    className: classes.logo,
                    style: {
                        height: useLogoOriginalSize ? "auto" : 35
                    }
                }), /*#__PURE__*/ React.createElement("span", {
                    contentEditable: isEditable,
                    suppressContentEditableWarning: true,
                    onKeyPress: this.handleTitleKeyPress,
                    onBlur: onTitleChange
                }, title))), /*#__PURE__*/ React.createElement("nav", {
                    className: cx(classes.navContainer, _defineProperty({}, classes.show, this.state.isMenuExpanded))
                }, /*#__PURE__*/ React.createElement("ul", null, this.props.pages.map(function(page) {
                    return /*#__PURE__*/ React.createElement("li", {
                        key: page.name
                    }, /*#__PURE__*/ React.createElement("a", {
                        className: cx({
                            active: page.name === activePage,
                            "slds-text-heading_small": isMobile
                        }),
                        "data-id": page.name,
                        onClick: _this.handleNavClick,
                        href: "#".concat(page.name)
                    }, page.label));
                }), this.renderAuthLinks()))), /*#__PURE__*/ React.createElement("div", {
                    className: cx("slds-grid", classes.contents)
                }, children))));
            }
        }
    ]);
    return DefaultTheme;
}(_Component = React.Component);
_defineProperty(DefaultTheme, "propTypes", {
    activePage: oneOfType([
        string,
        number
    ]),
    children: node,
    logo: string,
    useLogoOriginalSize: bool,
    mode: string,
    pages: arrayOf(shape({})),
    showAuthLinks: bool,
    title: string,
    isEditable: bool,
    isMobile: bool,
    onTitleChange: func,
    onNavClick: func,
    onLoginClick: func,
    onRegisterClick: func
});
_defineProperty(DefaultTheme, "defaultProps", {
    onLoginClick: function() {},
    onRegisterClick: function() {}
});
export default injectSheet(styles)(DefaultTheme);
